import { useState } from "react";
import { toast } from "sonner";
import { Hash, Check, Loader2, Pencil } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export function StockNumberField({ vehicle, onSaved }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(vehicle.stock_number || "");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.patch(`/vehicles/${vehicle.id}/stock`, { stock_number: value });
      onSaved?.(data);
      setEditing(false);
      toast.success(data.stock_number ? `Stock #${data.stock_number} saved — QR updated` : "Stock # cleared");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  if (editing) {
    return (
      <form onSubmit={save} className="flex items-center gap-1.5" data-testid={`stock-form-${vehicle.id}`}>
        <Hash className="h-3 w-3 text-slate-500 shrink-0" />
        <input
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => e.key === "Escape" && setEditing(false)}
          placeholder="Stock #"
          data-testid={`stock-input-${vehicle.id}`}
          className="h-6 w-28 rounded border border-[#0A8CF2]/60 bg-slate-950 px-1.5 font-mono-tech text-[11px] uppercase text-slate-100 outline-none"
        />
        <button type="submit" disabled={saving} data-testid={`stock-save-${vehicle.id}`} className="text-[#0A8CF2] hover:text-white">
          {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />}
        </button>
      </form>
    );
  }
  return (
    <button
      type="button"
      onClick={() => { setValue(vehicle.stock_number || ""); setEditing(true); }}
      data-testid={`stock-edit-${vehicle.id}`}
      title="Set the stock number printed on the QR code"
      className="group/stock flex items-center gap-1 font-mono-tech text-[10px] text-slate-500 hover:text-slate-200"
    >
      <Hash className="h-3 w-3" />
      {vehicle.stock_number ? <span className="text-slate-300">STOCK {vehicle.stock_number}</span> : <span className="italic">Add stock #</span>}
      <Pencil className="h-2.5 w-2.5 opacity-0 group-hover/stock:opacity-100 transition-opacity" />
    </button>
  );
}
